import { Component, inject } from '@angular/core'
import { SystemConfigService } from '@client/Services/SystemConfigService'
import { SetupOrderPaymentPlanComponent as GocardlessPaymentPlan } from '@client/Components/Orders/Order/PaymentPlans/Gocardless/SetupOrderPaymentPlan.Component'
import { PageComponent } from '@client/Components/ui/Page/Page.Component'
import { SetupOrderPaymentPlanComponent as ManualPaymentPlan } from '@client/Components/Orders/Order/PaymentPlans/Manual/SetupOrderPaymentPlan.Component'

@Component({
	selector: 'setup-order-payment-plan',
	templateUrl: './SetupOrderPaymentPlan.Component.html',
	imports: [GocardlessPaymentPlan, PageComponent, ManualPaymentPlan],
})
export class SetupOrderPaymentPlanComponent {
	protected readonly systemConfigService: SystemConfigService

	constructor() {
		this.systemConfigService = inject(SystemConfigService)
	}
}
